<template>
  <div class="question-note"
       v-if="note.show"
       :data-is-new="isNew"
       :data-state="note.editable ? 'edit' : 'view'"
       :data-show-list="note.showList"
       :data-sync="sync"
       :data-readonly="readonly"
       :class="{ ready: ready }"
       @click="onClick"
  >

    <div class="question-note-heading">
      <div class="question-note-user">
        <div v-if="!gravatarUrl" class="user-avatar no-avatar"
        >
          <div class="user-avatar-content">{{ note.initials }}</div>
        </div>
        <div v-else class="user-avatar has-avatar">
          <div class="user-avatar-content" :style="`background-image: url('${gravatarUrl}')`"></div>
        </div>

        <div class="question-note-meta">
          <div class="question-note-name">{{ note.value.user.firstName }} {{ note.value.user.lastName }}</div>
          <div class="question-note-date" v-if="note.dateString">{{ note.dateString }}</div>
        </div>
      </div>

      <div class="question-note-list-actions">
        <svg @click.stop="toggleList" class="question-note-list-actions-toggle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" xml:space="preserve">
          <path d="M12,20c-0.6,0-1-0.2-1.4-0.6C10.2,19,10,18.6,10,18s0.2-1,0.6-1.4C11,16.2,11.4,16,12,16s1,0.2,1.4,0.6C13.8,17,14,17.4,14,18s-0.2,1-0.6,1.4C13,19.8,12.6,20,12,20z M12,14c-0.6,0-1-0.2-1.4-0.6C10.2,13,10,12.6,10,12s0.2-1,0.6-1.4C11,10.2,11.4,10,12,10s1,0.2,1.4,0.6C13.8,11,14,11.4,14,12s-0.2,1-0.6,1.4C13,13.8,12.6,14,12,14z M12,8c-0.6,0-1-0.2-1.4-0.6C10.2,7,10,6.5,10,6s0.2-1,0.6-1.4C11,4.2,11.4,4,12,4s1,0.2,1.4,0.6C13.8,5,14,5.5,14,6s-0.2,1-0.6,1.4C13,7.8,12.6,8,12,8z"/>
        </svg>
        <div class="actions-list noselect" v-if="note.showList">
          <div class="list-item" @click.stop="onEdit">
            <svg class="list-item-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" xml:space="preserve">
              <path d="M4.2,15.8h1.2l7-7l-1.2-1.2l-7,7V15.8z M16.2,7.5l-3.7-3.7l1-1c0.3-0.3,0.8-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5L17.2,4c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2L16.2,7.5z M3.4,17.5c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6v-2.5c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3L11.2,5L15,8.8l-8.5,8.5c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1H3.4zM11.9,8.1l-0.6-0.6l1.2,1.2L11.9,8.1z"/>
            </svg>
            <div class="list-item-label">{{ $t('edit') }}</div>
          </div>
          <div class="list-item" @click.stop="isNew ? onHide() : onDelete()">
            <svg class="list-item-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" xml:space="preserve">
              <path d="M5.9,17.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.2V5.1C3.9,5.1,3.7,5,3.5,4.9C3.4,4.7,3.3,4.5,3.3,4.2s0.1-0.4,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.3h3.4c0-0.2,0.1-0.4,0.3-0.6C8,2.6,8.2,2.5,8.4,2.5h3.2c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6h3.4c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6s-0.1,0.4-0.3,0.6c-0.2,0.2-0.4,0.3-0.6,0.3v10.6c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.2,0.5H5.9z M5.9,5.1v10.6h8.2V5.1H5.9z M7.5,13.1c0,0.2,0.1,0.4,0.3,0.6C7.9,13.9,8.1,14,8.3,14c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6V7.8c0-0.2-0.1-0.4-0.3-0.6C8.8,7,8.6,6.9,8.3,6.9C8.1,6.9,7.9,7,7.7,7.1C7.5,7.3,7.5,7.5,7.5,7.8V13.1z M10.8,13.1c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3s0.4-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6V7.8c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.3S11.2,7,11,7.1c-0.2,0.2-0.3,0.4-0.3,0.6V13.1zM5.9,5.1v10.6V5.1z"/>
            </svg>
            <div class="list-item-label">{{ $t('delete') }}</div>
          </div>
        </div>
      </div>

      <svg class="question-note-sync" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" xml:space="preserve">
        <path d="M2,10c0-4.4,3.6-8,8-8s8,3.6,8,8h2c0-5.5-4.5-10-10-10S0,4.5,0,10c0,5.5,4.5,10,10,10v-2C5.6,18,2,14.4,2,10z"/>
      </svg>
    </div>

    <content-editable-component class="question-note-note"
                                :note="note"
                                ref="contentEditableComponent"
                                @input="onInput"
    />

    <div class="question-note-actions" v-if="note.editable">
        <button
            class="rect outline compact"
            type="button"
            @click.stop="isNew ? onHide() : onCancel()"
        >
          {{ $t('cancel') }}
        </button>
        <button
            class="rect compact"
            type="button"
            @click.stop="isNew ? onSave() : onUpdate()"
            :class="valid ? '' : 'disabled'"
        >
          <template v-if="isNew">{{ $t('add-note') }}</template>
          <template v-else>{{ $t('save-note') }}</template>
        </button>
    </div>

  </div>
</template>

<script lang="ts" setup>
import QuestionNote from './QuestionNote';
import { defineProps, getCurrentInstance, nextTick, onBeforeMount, onMounted, ref } from 'vue';
import { getGravatarUrl } from '../../../../core/Utils';
import Manager from '../../../../core/Manager';
import ContentEditableComponent from './ContentEditableComponent.vue';

const props = defineProps<{
  note: QuestionNote
}>();

const id = props.note.value.id;
const isNew = ref(id === null);
const valid = ref(false);
const vm = getCurrentInstance();
const contentEditableComponent = ref();
const gravatarUrl = ref();
const ready = ref(false);
const sync = ref(false);
const readonly = ref(false)

onMounted(() => {
  if(isNew.value) {
    onEdit();
  } else {
    if(props.note.value.user.email != Manager.getInstance().user.getEmail()) {
      readonly.value = true;
    }
  }
  let userEmail = props.note.value.user?.email ?? Manager.getInstance().user.getEmail();
  getGravatarUrl(userEmail).then((url) => {
    gravatarUrl.value = url;
  });
  nextTick(() => {
    ready.value = true;
  });
});

const onClick = () => {
  if(readonly.value) {
    return;
  }
  if(props.note.editable) {
    return;
  }
  onEdit();
}

const toggleList = () => {
  props.note.showList = !props.note.showList
  if(props.note.showList) {
    vm.emit('showlist');
    nextTick(() => {
      props.note.showList = true;
    })
  }
}

const onEdit = () => {
  props.note.editable = true;
  props.note.showList = false;
  contentEditableComponent.value.focus();
}

const onInput = () => {
  let v = true;
  if(!tt(props.note.value.note)) {
    v = false;
  }
  if(tt(props.note.value.note) === contentEditableComponent.value.initialValue) {
    v = false;
  }
  valid.value = v;
}

const onSave = async () => {
  props.note.value.note = tt(props.note.value.note);
  contentEditableComponent.value.onUpdate();
  props.note.editable = false;
  props.note.showList = false;
  valid.value = false;
  isNew.value = false;
  sync.value = true;
  await props.note.save();
  sync.value = false;
}

const onUpdate = async () => {
  props.note.value.note = tt(props.note.value.note);
  contentEditableComponent.value.onUpdate();
  props.note.editable = false;
  props.note.showList = false;
  valid.value = false;
  sync.value = true;
  await props.note.update();
  sync.value = false;
}

const onCancel = () => {
  contentEditableComponent.value.onCancel();
  props.note.editable = false;
  props.note.showList = false;
}

const onHide = () => {
  props.note.show = false;
}

const onDelete = async () => {
  props.note.show = false;
  await props.note.delete();
}

const tt = (text): string => {
  return text.trim();
}

</script>
